module.exports = __webpack_public_path__ + "static/assets/c297aff8d826b395d0c78a998f532688.svg";